export default __webpack_public_path__ + "static/media/014-Two way.b345b22a.png";